import { useMemo } from "react";
import { useMultiCurrencyConversions } from "hooks";
import { CURRENCY_NAMES } from "constants/index";

/**
 * useCurrencyConversionMatrix
 * Fetches all possible currency conversion combinations for USD, CAD, and EUR
 * Uses useMultiCurrencyConversions to optimize from 9 API calls to just 3
 * @returns {Object} conversionMatrix - Matrix with structure: matrix[fromCurrency][toCurrency] = rate
 */
export default function useCurrencyConversionMatrix() {
  const currencies = Object.values(CURRENCY_NAMES);

  const conversions = currencies.map((from) => useMultiCurrencyConversions({ from, toList: currencies }));

  // Build conversion matrix
  const conversionMatrix = useMemo(() => {
    const matrix = {};

    currencies.forEach((fromCurrency, index) => {
      matrix[fromCurrency] = {};
      currencies.forEach((toCurrency) => {
        matrix[fromCurrency][toCurrency] = conversions[index].data?.[toCurrency]?.conversionRate ?? 1;
      });
    });

    return matrix;
  }, [conversions.map(({ data }) => data)]);

  return conversionMatrix;
}
